"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "+ de 20 ans",
  "nbre": 27,
  "tjm_moyen": 695
}, {
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "11 à 20 ans",
  "nbre": 23,
  "tjm_moyen": 562
}, {
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "2 à 5 ans",
  "nbre": 7,
  "tjm_moyen": 483
}, {
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "6 à 10 ans",
  "nbre": 13,
  "tjm_moyen": 533
}, {
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "Moins de 2 ans",
  "nbre": 2,
  "tjm_moyen": 386
}, {
  "poste_cleaned": "Projeteur",
  "experience_pro": "+ de 20 ans",
  "nbre": 11,
  "tjm_moyen": 498
}, {
  "poste_cleaned": "Projeteur",
  "experience_pro": "11 à 20 ans",
  "nbre": 9,
  "tjm_moyen": 458
}, {
  "poste_cleaned": "Projeteur",
  "experience_pro": "2 à 5 ans",
  "nbre": "",
  "tjm_moyen": 364
}, {
  "poste_cleaned": "Projeteur",
  "experience_pro": "6 à 10 ans",
  "nbre": 2,
  "tjm_moyen": 414
}, {
  "poste_cleaned": "Projeteur",
  "experience_pro": "Moins de 2 ans",
  "nbre": "",
  "tjm_moyen": 291
}];
exports["default"] = _default;